import {AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {svgItems} from './svgItems';

@Component({
  selector: 'app-svg',
  templateUrl: './svg.component.html',
  styleUrls: ['./svg.component.scss']
})
export class SvgComponent implements OnInit, AfterViewInit {

  @Input()
  svg: string;

  @Input()
  classes: string;

  @ViewChild('svgDiv')
  svgDiv: ElementRef;

  svgHTML: string;

  constructor() {}

  ngOnInit(): void {
    this.svgHTML = svgItems()[this.svg];
  }
  ngAfterViewInit(): void {
    this.svgDiv.nativeElement.innerHTML = this.svgHTML;
  }

}
